// Créer une fonction qui retourne les routes avec la config des features
export const getAvailableRoutes = () => {
    return [
        // Routes pour l'authentification et la redirection
        { url: '/logout', available: true, requiredPrivileges: [] },
        { url: '/unauthorized', available: true, requiredPrivileges: [] },
        { url: '/', available: true, requiredPrivileges: [] }, // Root redirect

        // -------------------- Vision Admin --------------------
        { url: '/consultant', available: true, requiredPrivileges: [] },
        { url: '/consultant/:id', available: true, requiredPrivileges: ["ADMIN_USERS"] },
        { url: '/consultant/:id/statement', available: true, requiredPrivileges: ["ADMIN_STATEMENT"] },
        { url: '/consultant/:id/information', available: true, requiredPrivileges: ["ADMIN_USER_INFO_LIGHT", "ADMIN_USER_INFO_FULL"] },
        { url: '/consultant/:id/payslip', available: true, requiredPrivileges: ["ADMIN_PAYSLIP"] },
        { url: '/consultant/:id/timesheet', available: true, requiredPrivileges: ["ADMIN_TIMESHEET"] },
        { url: '/consultant/:id/expense', available: true, requiredPrivileges: ["ADMIN_EXPENSE"] },
        { url: '/consultant/:id/companyBenefit', available: true, requiredPrivileges: ["ADMIN_COMPANY_BENEFIT"] },
        { url: '/consultant/:id/overflow', available: true, requiredPrivileges: ["ADMIN_INVESTMENT"]},

        // Routes d'administration globales
        { url: '/overflowManagement', available: false, requiredPrivileges: ["ADMIN_INVESTMENT"], featureActivation: ["INVESTMENT_FEATURE"] },
        { url: '/overflowManagement/:investmentVehicleId', available: false, requiredPrivileges: ["ADMIN_INVESTMENT"], featureActivation: ["INVESTMENT_FEATURE"] },

        // Routes de gestion des prospects
        { url: '/prospects', available: true, requiredPrivileges: ["ADMIN_PROSPECTS"] },
        { url: '/prospects/cv', available: true, requiredPrivileges: ["ADMIN_PROSPECTS"] },
        { url: '/prospects/cv/:prospectID', available: true, requiredPrivileges: ["ADMIN_PROSPECTS"] },
        { url: '/prospects/cv/:prospectID/generate', available: true, requiredPrivileges: ["ADMIN_PROSPECTS"] },
        { url: '/prospects/cv/:prospectID/generate/:templateID', available: true, requiredPrivileges: ["ADMIN_PROSPECTS"] },
        { url: '/management', available: true, requiredPrivileges: [] },
        // Gestion des conditions du site (mentions legales) decommissionnee : routes conservees mais fermees.
        { url: '/management/website', available: false, requiredPrivileges: [] },
        { url: '/management/website/:type', available: false, requiredPrivileges: [] },
        { url: '/management/onboarding', available: true, requiredPrivileges: ["ADMIN_ONBOARDING"] },
        { url: '/management/onboarding/:candidateUuid', available: true, requiredPrivileges: ["ADMIN_ONBOARDING"] },

        // -------------------- Vision Consultant --------------------
        { url: '/administration', available: true, requiredPrivileges: [] },
        { url: '/administration/statement', available: true, requiredPrivileges: ["USER_STATEMENT"] },
        { url: '/administration/information', available: true, requiredPrivileges: ["OWN_PROFILE"] },
        { url: '/administration/payslip', available: true, requiredPrivileges: ["USER_PAYSLIP"] },
        { url: '/administration/expense', available: true, requiredPrivileges: ["USER_EXPENSE"] },
        { url: '/administration/companyBenefit', available: true, requiredPrivileges: ["USER_COMPANY_BENEFIT"] },
        { url: '/administration/timesheet', available: true, requiredPrivileges: ["USER_TIMESHEET"] },

        // Autres routes pour les consultants
        { url: '/overflow', available: true, requiredPrivileges: [] },
        { url: '/overflowSimulation', available: true, requiredPrivileges: [] },
        { url: '/overflow/simulate', available: true, requiredPrivileges: [], featureActivation: ["INVESTMENT_FEATURE"] },
        { url: '/overflow/:investmentVehicleId', available: true, requiredPrivileges: ["USER_INVESTMENT"], featureActivation: ["INVESTMENT_FEATURE"] },


        // -------------------- Page d'erreur pour les mobiles et erreurs générales --------------------
        { url: '/*', available: true, requiredPrivileges: [] }, // Changé de '*' à '/*'
    ];
};

// Exportation par défaut pour la compatibilité
export const availableRoutes = getAvailableRoutes();
